// extracted by mini-css-extract-plugin
export default {"ToggleButton":"QghbgH","toggleButton":"QghbgH"};